import { Theme } from '@mui/material';

export const baseIconButtonStyle = {
  borderRadius: '12px',
  padding: '8px',
  transition: 'all 0.2s ease-in-out',
  '&:hover': {
    transform: 'scale(1.08)',
  },
};

export const getColorSet = (theme: Theme, key: keyof Theme['palette']) => {
  const paletteColor = theme.palette[key];

  if (
    typeof paletteColor === 'object' &&
    paletteColor !== null &&
    'main' in paletteColor &&
    'light' in paletteColor &&
    'dark' in paletteColor
  ) {
    const main = paletteColor.main;
    const hoverBg =
      theme.palette.mode === 'dark' ? paletteColor.light : paletteColor.dark;

    return {
      color: main,
      '&:hover': {
        backgroundColor: `${hoverBg}22`,
        color: hoverBg,
      },
    };
  }

  return {};
};
